import React from 'react'
import { Route } from 'react-router';
import { createRouteMap } from './routes';

const RouteMaker = ({allowedRoutesList}) => {

  // Create a route map, which will just have 
  // a right page (component) and string as a key
  // For example "HomePage" and Homepage function
  // This is needed because it is not wise to put functions
  // in the Store. 
  const routeMap = createRouteMap();

  let routes = [];

  // Creates route for each allowed route. So there will be no 
  // protected routes, because any route that is not allowed will
  // not be created in the first place.
  if (allowedRoutesList && allowedRoutesList.length > 0 ) {
    for (let i = 0; i < allowedRoutesList.length; i++) {
      
      const routeInfo = allowedRoutesList[i];
      

      if (routeInfo.title && routeInfo.pages) {
        
        for (let j = 0; j < routeInfo.pages.length; j++) {
          const routeInfoSub = routeInfo.pages[j];
          routes.push(<Route key={routeInfoSub.name} exact path={routeInfoSub.path} component={routeMap.get(routeInfoSub.component)} />)
        }

      } else {
        routes.push(<Route key={routeInfo.name} exact path={routeInfo.path} component={routeMap.get(routeInfo.component)} />)
      }
    }
    
    // routes = allowedRoutesList.map(routeObject => {
    //   return <Route exact path={routeObject.path} key={routeObject.name} component={routeMap.get(routeObject.component)} />
    // })
  } else { }
  return routes;
}

export default RouteMaker;


// WEBPACK FOOTER //
// ./src/utils/RouteMaker.js